import React from 'react'
import { convertShortcodesToHTML, filterBlockByType } from '../../../services/common'
import { icon } from '../../../services/icon'

const Table = ({ block }) => {
    const titleBlock = filterBlockByType(block.childrens, 'Titre')
    const tableHead = block?.childrens?.find(
        (child) => child.attributes.type === 'header'
    ).childrens
    const tableRows = block?.childrens?.filter((child) => child.attributes.type === 'normal')

    return (
        <div className="table baseocom-block-table baseocom-mb-10">
            {titleBlock && (
                <h4 className="baseocom-title">
                    <span>{icon('table')}</span>
                    Tableau - {titleBlock?.content}
                </h4>
            )}
            <div className="baseocom-container">
                <table>
                    <thead>
                        <tr>
                            {tableHead?.map((child, index) => (
                                <th key={child?.ID}>{convertShortcodesToHTML(child?.content)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableRows?.map((row, index) => (
                            <tr
                                key={index}
                                className={`${index % 2 === 0 ? 'baseocom-bg-gray-100' : 'baseocom-bg-gray-200'} `}
                            >
                                {row.childrens.map((child, index) => (
                                    <td
                                        colSpan={child.attributes.fusionHorizontale || 1}
                                        key={index}
                                    >
                                        {convertShortcodesToHTML(child?.content)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Table
